'use strict';

module.exports = function (string) {
	return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tscom-util/src/capitalize.js
// module id = 235
// module chunks = 0